import { useContext, useRef } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import UiContext from "@store/ui-context";
import JabatanSelectorList from "./jabatan-selector-list";

const titleDefault = "Pilih Jabatan";

/**
 * Jabatan selector dialog.
 *
 * props:
 * - visible, onHide
 * - onConfirm(event, rows): rows is always an array, even in single mode
 * - title, additionalFilter, multiple, selected (row or rows to preselect)
 */
const JabatanSelectorMain = (props) => {
  const listRef = useRef(null);
  const { onConfirm, onHide, visible, title, multiple } = props;

  const uiContext = useContext(UiContext);

  // handle ui event section

  const handleOnClickPilih = (e) => {
    const listSelected = listRef.current.getSelectedData();
    const rows = Array.isArray(listSelected)
      ? listSelected
      : [listSelected].filter((row) => row);

    if (rows.length === 0) {
      uiContext.showErrorMsg("Error", "Pilih data terlebih dahulu");
      return;
    }

    onConfirm(e, rows);
  };

  const dialogFooter = (
    <div className="row-end-end w-100 pt-2">
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={onHide}
      />
      <Button label="Pilih" icon="pi pi-check" onClick={handleOnClickPilih} />
    </div>
  );

  return (
    <Dialog
      blockScroll
      visible={visible}
      header={title ?? titleDefault}
      modal
      className={`p-fluid w-[34rem]`}
      breakpoints={{ "960px": "75vw", "641px": "95vw" }}
      footer={dialogFooter}
      onHide={onHide}
      contentStyle={{ paddingBottom: "0px" }}
    >
      <div className={`col-start-start w-100 gap-3 pt-1`}>
        <JabatanSelectorList ref={listRef} {...props} multiple={multiple} />
      </div>
    </Dialog>
  );
};

export default JabatanSelectorMain;
